module.exports = __webpack_public_path__ + "202e54913bc6170a0533420d33ba4c53.pdf";